import { gameLiveConnection } from '../services';

import { backgroundDrawer } from '../game/drawers/background';
import { gameDrawer } from '../game/drawers/gameDrawer';

class LiveConnection {
  isConnected = false;

  handleSocketInit() {
    gameLiveConnection?.init().then(() => {
      this.isConnected = true;
      this.connectionInitCallback();
    });
  }

  restartGameConnection() {
    return new Promise((res) => {
      gameLiveConnection.stop().then(() => {
        gameLiveConnection.init().then(() => {
          this.connectionInitCallback();
          res();
        });
      });
    });
  }

  connectionInitCallback = (bool) => {
    if (this.isConnected) {
      backgroundDrawer.clearTracks();
      gameDrawer
        .execute({
          mode: 'web',
          scene: 'Main',
          prevScene: null,
        })
        .then(() => {
          gameLiveConnection.sendGameGetInitialState(bool).then(() => {});
        });
    }
  };
}

export const liveConnection = new LiveConnection();
